import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "./Header";
import Footer from "./Footer";
import AccountDeletionScheduledBanner from "../components/AccountDeletionScheduledBanner";
import useAuthCheck from "../utils/use-auth-check";
import { useGetUserInfoQuery } from "../libs/provider";
import Spinner from "../components/loaders/Spinner";

const PageContainer = () => {
  const userContext = useSelector((state) => state.metadata?.userContext ?? {});
  const { accountDeletionStatus, deletionScheduledFor, isEmailVerified } =
    useSelector((state) => state.metadata);
  const isAuthenticated = useSelector((state) => state.auth?.auth);

  useAuthCheck();
  const { isLoading } = useGetUserInfoQuery();

  if (isLoading) {
    return (
      <div className="main min-h-screen w-full flex items-center justify-center no-scrollbar">
        <Spinner />
      </div>
    );
  }

  const handleCancelDeletionSuccess = () => {
    // Refetch user info to update the metadata
    window.location.reload();
  };

  const isDeletionScheduled = accountDeletionStatus === "pending_deletion";

  return (
    <div className="main min-h-screen w-full no-scrollbar">
      <Header />
      {isDeletionScheduled && deletionScheduledFor && (
        <AccountDeletionScheduledBanner
          deletionScheduledFor={deletionScheduledFor}
          onCancelSuccess={handleCancelDeletionSuccess}
        />
      )}
      <div className="page-wrap px-5 md:px-10 py-8 md:py-10 no-scrollbar">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default PageContainer;
